<template>
  <!--仓储-->
  <div class="order-info">
    <div class="main">
      <el-form
        ref="ruleForm"
        :model="formInline"
        label-width="6em"
        :inline="true"
      >
        <div :style="{height : showMore ? 'auto': '60px'}" class="condition-area">
          <div class="icon-content" @click="toggleShowMore">
            <i :class="[showMore?'iconshang':'iconxia']" class="icon iconfont" />
          </div>
          <div class="condition-group">
            <el-form-item prop="orderNum" label="订单编号">
              <el-input
                v-model.trim="formInline.orderNum"
                placeholder="请输入"
                :rules="rules"
                @keyup.enter.native="getData"
              />
            </el-form-item>
            <el-form-item prop="orderStatus" label="订单状态">
              <el-select v-model="formInline.orderStatus" placeholder="请选择">
                <el-option v-for="item in dict.storageOrderStatus" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item prop="storageType " label="仓储类型">
              <el-select v-model="formInline.storageType" placeholder="请选择">
                <el-option v-for="item in dict.warehouseType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item prop="houseGoodsType" label="储货类型">
              <el-select v-model="formInline.houseGoodsType" placeholder="请选择">
                <el-option v-for="item in dict.goodsType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item prop="dateval" label="租用日期">
              <el-date-picker
                v-model="formInline.dateval"
                type="daterange"
                value-format="yyyy-MM-dd"
                :editable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              />
            </el-form-item>
            <el-form-item prop="rentDateval" label="生成日期">
              <el-date-picker
                v-model="formInline.rentDateval"
                type="daterange"
                value-format="yyyy-MM-dd"
                align="right"
                :editable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </div>
        </div>
        <div class="button-group">
          <el-form-item class="form-item form-item-sou">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="query"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="resetForm('ruleForm')"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="table">
      <div class="table-warp">
        <div class="table-head">
          <el-row class="center">
            <el-col :span="3">订单编号</el-col>
            <el-col :span="3">仓储类型</el-col>
            <el-col :span="3">仓单名称</el-col>
            <el-col :span="3">需求单位</el-col>
            <el-col :span="3">供给单位</el-col>
            <el-col :span="3">订单价格</el-col>
            <el-col :span="3">订单状态</el-col>
            <el-col :span="3">操作</el-col>
          </el-row>
        </div>
        <div v-loading="loading" class="table-body">
          <template v-if="!loading && tableData.length < 1">
            <div class="no-data-info">
              <font>暂无匹配数据</font>
            </div>
          </template>
          <div v-for="(item, index) in tableData" :key="index" class="table-body-item">
            <el-row type="flex" align="middle" class="center table-body-item-head">
              <el-col :span="3">
                <div v-if="item.cmsStorageOrder" :title="item.cmsStorageOrder.orderNum">{{ item.cmsStorageOrder.orderNum }}</div>
              </el-col>
              <el-col :span="3">
                <div :title="item.storageType">{{ item.tankGoodsType }}</div>
              </el-col>
              <el-col :span="3">
                <div v-if="item.cmsStorageOrder" :title="item.cmsStorageOrder.storageName">{{ item.cmsStorageOrder.storageName }}</div>
              </el-col>
              <el-col :span="3">
                <div class="logo">
                  <img v-if="item.cmsStorageOrder" :src="item.cmsStorageOrder.demandCompanyLogo | getImg"  alt>
                </div>
                <div v-if="item.cmsStorageOrder" :title="item.cmsStorageOrder.demandCompany" class="name">{{ item.cmsStorageOrder.demandCompany }}</div>
              </el-col>
              <el-col :span="3">
                <div class="logo">
                  <img v-if="item.cmsStorageOrder" :src="item.cmsStorageOrder.supplyCompanyLogo | getImg"  alt>
                </div>
                <div v-if="item.cmsStorageOrder" :title="item.cmsStorageOrder.supplyCompany" class="name">{{ item.cmsStorageOrder.supplyCompany }}</div>
              </el-col>
              <el-col :span="3">
                <div v-if="item.cmsStorageOrder" :title="item.cmsStorageOrder.money">{{ item.cmsStorageOrder.money }}元</div>
              </el-col>
              <el-col :span="3">
                <div v-if="item.cmsStorageOrder" :title="item.orderStatus" :style="{color: orderStatus(item.orderStatus)}">{{ item.orderStatus }}</div>
              </el-col>
              <el-col :span="3">
                <!--userType==3&&-->
                <div v-if="item.orderStatus=='待确认'" style="margin-bottom: 12px;padding-left: 0">
                  <el-button
                    style="width: 2.5rem;background-color: #be2316;color: white!important;border-color: #be2316;"
                    type="text"
                    plain
                    size="small"
                    @click="determine(item)"
                  >
                    确定</el-button>
                  <el-button
                    style="width: 2.5rem;background-color: white;color: #be2316!important;border-color: #be2316;"
                    type="text"
                    plain
                    size="small"
                    @click="refuse(item)"
                  >拒绝</el-button>
                </div>
                <el-button v-if="item.orderStatus == '待支付'" style="color: #66b1ff;" type="text" @click="cancel(item)">取消订单</el-button>
                <el-button
                  class="details"
                  plain
                  size="small"
                  @click="active == index ? active = -1 : active = index"
                >详情<i :class="{expand: active == index ? true : false}" class="el-icon-d-arrow-right" />
                </el-button>
              </el-col>
            </el-row>
            <transition name="fade">
              <storage-order-list-table-item v-if="active == index" :table-data="item" />
            </transition>
          </div>
        </div>
        <!-- 分页 -->
        <article class="main-pagination">
          <el-pagination
            :current-page="pagination.pageNo"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            layout="prev, pager, next, jumper,total, sizes"
            @current-change="changeCurrent"
            @size-change="changeSize"
          />
        </article>
      </div>
    </div>
    <CancelDialog
      v-if="dialogShow"
      :dialog-show="dialogShow"
      :pop-data="cancelPopData"
      :status="statusType"
      @getList="getData"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
// import { , deleteStorageOrder, determineOrder, refuseOrder } from '@/api/monitor/orderInfo'
import { getTankOrderListAll, determineOrder, refuseOrder } from '@/api/monitor/orderInfo'
import { completeStorageOrder } from '@/api/monitor/orderInfo'
import { getDict } from '@/api/common'
import { Page } from '@/utils/commonDataModel'
import storageOrderListTableItem from '../components/storageOrderListTableItem'
import CancelDialog from './components/cancelDialog'

export default {
  name: 'OrderList',
  components: {
    storageOrderListTableItem,
    CancelDialog
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    const pickerOptions = {
      shortcuts: [
        {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }
      ]
    }
    return {
      // 取消订单弹窗状态
      dialogShow: false,
      cancelPopData: [],
      statusType: 'storage',
      showMore: false,
      // 时间选择器快捷方式
      pickerOptions,
      // 查询条件
      formInline: {
        // 租用时间数组
        rentDateval: [],
        // 时间数组
        dateval: [],
        orderNum: '', // 订单编号
        orderStatus: '', // 订单状态
        houseGoodsType: '', // 货物类型
        storageType: '', // 仓储类型
        leaseStartTime: '', // 租用开始日期
        leaseEndTime: '', // 租用结束日期
        startDate: '', // 创建开始日期
        endDate: '', // 创建结束日期
        supplyId: '',
        demandCompanyId: ''
      },
      // 正则
      rules: {
        orderNum: [{ validator: this.$validate('username') }]
      },
      // 字典
      dict: {
        goodsType: [], // 货物类型
        warehouseType: [], // 仓储类型
        storageOrderStatus: [] // 订单状态
      },
      // 货物类型字典
      // 展开详情的索引
      active: -1,

      // 数据
      tableData: [],
      loading: true,
      // 分页数据
      pagination: new Page()
    }
  },
  watch: {
    // 处理获取到的时间格式
    'formInline.dateval': {
      handler(val) {
        let start = ''
        let end = ''
        if (val) {
          start = val[0]
          end = val[1]
        }
        this.formInline.leaseStartTime = start
        this.formInline.leaseEndTime = end
      },
      deep: true
    },
    // 处理获取到的时间格式
    'formInline.rentDateval': {
      handler(val) {
        let start = ''
        let end = ''
        if (val) {
          start = val[0]
          end = val[1]
        }
        this.formInline.startDate = start
        this.formInline.endDate = end
      },
      deep: true
    }
  },
  created() {
    this.getDict('goodsType')
    this.getDict('warehouseType')
    this.getDict('storageOrderStatus')
    // 预约页面过来的
    if (this.$route.params.data != undefined) {
      console.log('仓储', this.$route.params.data)
      this.formInline.supplyId = this.$route.params.data.id
      this.formInline.demandCompanyId = this.userInfo.companyId
      this.getData()
    }
    // 消息通知过来的数据
    if (this.$route.params.noticeId != undefined) {
      // console.log('消息通知过来的数据(storageOrderList)', 'id:' + this.$route.params.noticeId, 'type:' + this.$route.params.noticeMark)
      const oid = {
        id: this.$route.params.data.noticeModuleId
      }
      getTankOrderListAll(Object.assign({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.pageNo
      }, oid)).then(res => {
        this.tableData = res.result.rows
        console.log(349, this.tableData)
        this.pagination.total = res.result.total
        this.loading = false
      })
    } else {
      this.getData()
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.query()
      }
    }
  },
  methods: {
    // 确定
    determine(item) {
      determineOrder({
        demandCompanyId: item.cmsStorageOrder.demandCompanyId,
        createDate: item.cmsStorageOrder.createDate,
        demandCompany: item.cmsStorageOrder.demandCompany,
        supplyCompany: item.cmsStorageOrder.supplyCompany,
        orderNum: item.cmsStorageOrder.orderNum,
        supplyCompanyId: item.cmsStorageOrder.supplyCompanyId,
        supplyUser: item.cmsStorageOrder.supplyUser,
        createBy: item.cmsStorageOrder.createBy.userId,
        id: item.id,
        orderStatus: 1,
        orderType: item.cmsStorageOrder.orderType }).then(data => {
        this.$message({
          message: '确认成功',
          type: 'success'
        })
        this.getData()
      })
    },
    // 拒绝
    refuse(item) {
      refuseOrder({
        id: item.id,
        supplyCompanyId: item.cmsStorageOrder.supplyCompanyId,
        demandCompanyId: item.cmsStorageOrder.demandCompanyId,
        orderNum: item.cmsStorageOrder.orderNum,
        storageOrderId: item.storageOrderId,
        createBy: item.cmsStorageOrder.createBy.userId,
        orderType: item.cmsStorageOrder.orderType }).then(data => {
        this.$message({
          message: '拒绝成功',
          type: 'success'
        })
        this.getData()
      })
    },
    // 取消订单
    cancel(item) {
      this.dialogShow = true
      this.cancelPopData = item
      // deleteStorageOrder({
      // orderNum: item.cmsStorageOrder.orderNum,
      //   supplyCompanyId: item.cmsStorageOrder.supplyCompanyId,
      //   demandCompanyId: item.cmsStorageOrder.demandCompanyId,
      //   id: item.id,
      //   storageOrderId: item.storageOrderId,
      //   orderType: item.cmsStorageOrder.orderType
      // }).then(data => {
      //   this.$message({
      //     message: '取消成功',
      //     type: 'success'
      //   })
      //   this.getData()
      // })
      // deleteStorageOrder().then
    },
    // 关闭取消订单修改弹窗
    closeDialog() {
      this.dialogShow = false
    },
    // 获取数据
    getData() {
      const params = JSON.parse(JSON.stringify(this.formInline))
      params.rentDateval = JSON.stringify(params.rentDateval)
      params.dateval = JSON.stringify(params.dateval)
      getTankOrderListAll(Object.assign({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.pageNo
      }, params)).then(res => {
        console.log(437,res)
        this.tableData = res.result.rows
        this.pagination.total = res.result.total
        this.loading = false
      })
    },
    // 获取字典
    getDict(type) {
      getDict(type).then(res => {
        this.dict[type] = JSON.parse(res.result)
      })
    },
    // 查询
    query() {
      this.getData()
    },
    toggleShowMore() {
      this.showMore = !this.showMore
    },
    // 订单状态字体颜色
    orderStatus(status) {
      const obj = {
        运输中: '#148B00',
        待运输: '#E56100'
      }
      return obj[status]
    },
    // 货物类型icon
    goodstypeicon(goodsType) {
      const obj = {
        成品油: 'iconyoupin',
        原油: 'iconyuanyou',
        化工品: 'iconhuagongpin'
      }
      return obj[goodsType]
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.getData()
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination = new Page()
      this.pagination.pageSize = size
      this.getData()
    },
    resetForm(formName) {
      // console.log(this.$refs[formName])
      this.$refs[formName].resetFields()
      // this.formInline.supplyId = ''
      // this.formInline.demandCompanyId = ''
      // this.formInline.storageType = ''
      // setTimeout(function() {
      this.getData()
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles/standardColor.scss";
  @import "@/styles/formLayout.scss";
  @import "../order-list.scss";
  /*仓储和罐区的样式*/
  @import "../reserve-order-list.scss";
</style>
